import { connect } from 'react-redux'
import Newsletter from './newsletter'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../stores/user/user.selectors'
import { updateNewsletter } from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { me }) => {
  const user = getUser(state)
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    pending: updateAccountDetails.pending,
    newsletter: user.newsletter,
    newsletterAvailability: user.newsletter_availibility // is Mailchimp API available
  }
}

const mapDispatchToProps = dispatch => ({
  onNewsletterChange: e =>
    dispatch(updateNewsletter({ newsletter: e.target.checked }))
      .then(() =>
        toast.success('Your newsletter subscription was successfully updated.')
      )
      .catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Newsletter)
